import {TCurrency, TFilter, TList, TUUID} from '@/types';
import {getGroup, getPayoutMerchantList} from './mock';
import {apiRequestAdmin} from '../../ws';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {Nium, TGroup, TGroupType, TPayoutMerchant} from './types';
import {
  ENDPOIN_ADMIN_PO_GET,
  ENDPOIN_ADMIN_PO_CANDIDATES
} from '../../../constants/api';

type TPayoutGroupGetParams = {group_id: TUUID, group_type: TGroupType};
// Возвращает информацию по конкретной группе выплат (если она существует)
export function apiAdminPayoutGroupGet(params: TPayoutGroupGetParams): Promise<TGroup<Nium>> {
  const url = ENDPOIN_ADMIN_PO_GET;
  if (process.env.MOCK) {
    const response = getGroup(params.group_type);
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  delete params.group_type;
  return apiRequestAdmin(url, params);
}

// Возвращает список мерчантов
export function apiAdminPayoutMerchantList(
    params: TFilter<{fiat_code: TCurrency}>,
): Promise<TList<TPayoutMerchant>> {
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;
  const url = ENDPOIN_ADMIN_PO_CANDIDATES;

  if (process.env.MOCK) {
    const response = {
      list: getPayoutMerchantList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}
